// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__-lTkz","content":"GlobalSearch_content__3rxn5"};